import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment-timezone';
import { IAttendee, IEvent, IEventAttendeeData } from '../../types/datatypes';

@Component({
	selector: 'app-event-details-card',
	templateUrl: './event-details-card.component.html',
	styleUrls: ['./event-details-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class EventDetailsCardComponent {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input({ required: true }) event!: IEvent;

	// TODO: Use populated variant
	@Input() attendees: IAttendee[] = [];

	@Input() form: FormGroup = null;

	@Input() attendeeData: IEventAttendeeData = null;

	@Input() mode: 'view' | 'signup' | 'edit' = 'view';

	@Output() submitEvent = new EventEmitter<IEventAttendeeData>();

	public calendarIcon = faCalendarAlt;

	get isPastDeadline() {
		const deadline = new Date(this.event.tickets.sellout);
		const now = new Date();
		return now >= deadline;
	}

	get isEventSoldOut(): boolean {
		return this.event.attendeesCount >= this.event.tickets.inventory;
	}

	get isEventComplete(): boolean {
		const endDate = new Date(this.event.time.end);
		const now = new Date();
		return this.event.status === 'published' && now >= endDate;
	}

	constructor(
	) { }

	getFormattedDate() {
		const date = moment(this.event.time.start).tz('America/New_York').format('MMM D, YYYY h:mm A z');
		return date;
	}

	onSubmit() {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}
		const formData = {
			...this.form.value,
		} as IEventAttendeeData;
		this.submitEvent.emit(formData);
	}

	hasErrors(fieldName: string): boolean {
		return this.form.touched && this.form.get(fieldName).touched && !!Object.keys(this.form.get(fieldName)?.errors ?? {}).length;
	}
}
